import React from 'react';
import { Flex, Typography } from 'antd';
import styles from './index.less';

const CopyableId: React.FC<{ id: string }> = ({ id }) => {
  if (!id) return null;

  return (
    <Flex className={styles.container}>
      <Typography.Text type="secondary" className={styles.label}>
        ID
      </Typography.Text>
      <Typography.Text code copyable className={styles.idValue} ellipsis>
        {id}
      </Typography.Text>
    </Flex>
  );
};

export default CopyableId;
